import { Text } from '@react-three/drei';

function LTPanel({ position, size, onHover, component, onClick }) {
  const [width, height, depth] = size;
  return (
    <group position={position}>
      <mesh
        onPointerOver={() => onHover(component.name)}
        onPointerOut={() => onHover(null)}
        onClick={() => onClick(component)}
        castShadow
        receiveShadow
      >
        <boxGeometry args={[width, height, depth]} />
        <meshLambertMaterial color='#f3f4f6' />
      </mesh>

      <mesh position={[0, 0, depth / 2 + 0.01]}>
        <planeGeometry args={[width * 0.9, height * 0.9]} />
        <meshLambertMaterial color='#e5e7eb' transparent opacity={0.3} />
      </mesh>

      {Array.from({ length: 6 }).map((_, i) => (
        <mesh
          key={i}
          position={[
            -width / 3 + (i * width) / 8,
            height / 4,
            depth / 2 + 0.02,
          ]}
        >
          <boxGeometry args={[width / 12, height / 8, 0.1]} />
          <meshLambertMaterial color='#fca5a5' />
        </mesh>
      ))}

      <mesh position={[0, -height / 4, depth / 2 + 0.02]}>
        <boxGeometry args={[width / 4, height / 6, 0.1]} />
        <meshLambertMaterial color='#f87171' />
      </mesh>

      <mesh position={[0, 0, depth / 2 + 0.01]}>
        <boxGeometry args={[width * 0.8, 0.1, 0.05]} />
        <meshLambertMaterial color='#fde68a' />
      </mesh>

      <mesh position={[width / 3, -height / 3, depth / 2 + 0.02]}>
        <cylinderGeometry args={[0.1, 0.1, 0.05]} />
        <meshLambertMaterial color='#d1d5db' />
      </mesh>

      <mesh position={[-width / 2 - 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height, depth * 0.3]} />
        <meshLambertMaterial color='#e5e7eb' />
      </mesh>
      <mesh position={[width / 2 + 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height, depth * 0.3]} />
        <meshLambertMaterial color='#e5e7eb' />
      </mesh>

      <group position={[-2, height + 3, 0]}>
        {/* First line - BIG FONT */}
        <Text
          fontSize={1.3}
          color='black'
          anchorX='left'
          anchorY='bottom'
          outlineColor='#000000ff'
          fontWeight={700}
        >
          {component.name}
        </Text>

        {/* Next 2 lines - SMALL FONT only if value exists */}
        {(component.details?.Brand_name ||
          component.details?.Quantity ||
          component.details?.Specification) && (
          <Text fontSize={0.9} color='black' anchorX='left' anchorY='top'>
            {`${component.details?.Brand_name || ''}\nx${component.details?.Quantity || '0'}\n${component.details?.Specification || ''}`}
          </Text>
        )}
      </group>
    </group>
  );
}

export default LTPanel;
